import { render, staticRenderFns } from "./PrenotazioniCalendar.vue?vue&type=template&id=e7693c1a&scoped=true&"
import script from "./PrenotazioniCalendar.vue?vue&type=script&lang=js&"
export * from "./PrenotazioniCalendar.vue?vue&type=script&lang=js&"
import style0 from "./PrenotazioniCalendar.vue?vue&type=style&index=0&id=e7693c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7693c1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VDatePicker,VFlex,VIcon,VLayout})
